const CONTRACT_FORM_UUID = "21985ae1b41e402c9e1fb9c275e3289d";
const ACTIVE_CONTRACT_STATUS = "f0f77f8e-1899-4f6d-a5ea-6a98e3c548f2";

const buildActiveContractQuery = (organizationId) => ({
  form_head_uuid: CONTRACT_FORM_UUID,
  page: 1,
  limit: 20,
  keyword: "",
  select_option: "",
  lt4vcwktnu62m6iu: ACTIVE_CONTRACT_STATUS,
  jho0wnl3gm3tjoci: [`[${organizationId}]`],
});

const firstRelationValue = (value) => {
  if (!Array.isArray(value)) return null;
  return Array.isArray(value[0]) ? value[0][0] || null : value[0] || null;
};

const normalizeContractContact = (contracts) => {
  if (!Array.isArray(contracts)) return null;
  for (let index = 0; index < contracts.length; index += 1) {
    const contract = contracts[index];
    if (!contract) continue;
    const manager = firstRelationValue(contract["2l9jxh6ktj1ki60e"]);
    const qrCode = firstRelationValue(contract.zyrdfqdoeieeyktb);
    const contact = {
      name: manager && (manager.value || manager.name || ""),
      phone: contract.jsoslbqrkkj4fc7m ? String(contract.jsoslbqrkkj4fc7m) : "",
      qrCodeUrl: qrCode && (qrCode.url || qrCode.path || qrCode.value || ""),
    };
    if (contact.phone || contact.qrCodeUrl) return contact;
  }
  return null;
};

module.exports = { buildActiveContractQuery, normalizeContractContact };



// WEBPACK FOOTER //
// ./src/util/contractContact.js